import { Client } from '@twilio/conversations';

const getTwilioConversationsClient = async (token) => {
  console.log('creating conversationClient');
  const client = new Client(token);
  return client;
};

export default getTwilioConversationsClient;
